import { CodeBlockBracesIcon } from './CodeBlockBracesIcon';

/**
 * author: frankgrinaert
 * id C74E1367-3799-4422-8065-A200D4CAB498
 * name code-block-braces
 * version: 7.3.67
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/code-block-braces.svg
 * tags
 * - Developer / Languages 
 */
export const CodeBlockTagIcon = CodeBlockBracesIcon;
export default CodeBlockTagIcon